import { DictContext, DictContent, DictByFormatArg, fetchDictWithFormat } from "lib/dict";
import { createContext as _createContext, useContext as _useContext, useState, PropsWithChildren, useEffect } from "react";

type DictProviderProps = {
  dictFromPage: DictContent;
  debug: boolean;
  namespacesSpecifiedInPage: string[];
};

export function DictProvider({ dictFromPage, debug, namespacesSpecifiedInPage, children }: PropsWithChildren<DictProviderProps>) {
  const [dict, setDict] = useState<DictContent>(dictFromPage);
  const [dictByFormatArgs, setDictByFormatArgs] = useState<DictByFormatArg[]>([]);

  // これがないとnextjsのrouter遷移で
  // dictFromPage: 新しいのになってる
  // dict: 古いのになってる
  // となってしまう
  useEffect(() => {
    setDict(dictFromPage);
  }, [dictFromPage]);

  useEffect(() => {
    if (dictByFormatArgs.length === 0) {
      return;
    }
    if (dictByFormatArgs.some((arg) => !arg.kind || !arg.ns || !arg.format_id)) {
      return;
    }
    // fetchDictWithFormatをよんで、dictを更新する
    const fetchDict = async () => {
      try {
        const fetchedDict = await fetchDictWithFormat(namespacesSpecifiedInPage, dictByFormatArgs);
        setDict(fetchedDict);
      } catch (error) {
        console.error("Failed to fetch per formart dict", error);
      }
    };
    fetchDict();
  }, [dictByFormatArgs, namespacesSpecifiedInPage]);

  return (
    <DictContext.Provider
      value={{
        dict: dict,
        debug: debug,
        dictByFormatArgs: dictByFormatArgs,
        setDictByFormatArgs: (args: DictByFormatArg[]) => {
          setDictByFormatArgs((prevArgs) => {
            // 既存の設定と新しい設定をマージ
            // 単価登録側が親でsetDictByFormatArgsをよんで、その中で見積側がsetDictByFormatArgsを呼ぶ
            // のようなネストがある場合に対応
            const mergedArgs = [...prevArgs];
            args.forEach((newArg) => {
              const existingIndex = mergedArgs.findIndex((arg) => arg.ns === newArg.ns && arg.kind === newArg.kind);

              if (existingIndex >= 0) {
                // 既存で同じns, 同じkind(format)のものがあれば上書き
                mergedArgs[existingIndex] = newArg;
              } else {
                // なければ追加
                mergedArgs.push(newArg);
              }
            });
            return mergedArgs;
          });
        },
      }}
    >
      {children}
    </DictContext.Provider>
  );
}
